import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { ProspectDetails_FieldsFragmentDoc } from './sales-portal-prospect-details-fragments.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEditableProspectDocument = gql`
  query SalesPortalEditableProspect(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getSalesPortalProspectDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...ProspectDetails_Fields
    }
  }
  ${ProspectDetails_FieldsFragmentDoc}
`;
export function useSalesPortalEditableProspectQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >(SalesPortalEditableProspectDocument, options);
}
export function useSalesPortalEditableProspectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >(SalesPortalEditableProspectDocument, options);
}
export type SalesPortalEditableProspectQueryHookResult = ReturnType<
  typeof useSalesPortalEditableProspectQuery
>;
export type SalesPortalEditableProspectLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEditableProspectLazyQuery
>;
export type SalesPortalEditableProspectQueryResult = Apollo.QueryResult<
  Types.SalesPortalEditableProspectQuery,
  Types.SalesPortalEditableProspectQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEditableProspectQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEditableProspectQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >(SalesPortalEditableProspectDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEditableProspectLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEditableProspectLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEditableProspectQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEditableProspectQuery,
    Types.SalesPortalEditableProspectQueryVariables
  >(SalesPortalEditableProspectDocument, lazyOptions);
}
